import React from "react";
import { TYPE_VISUAL } from "./FlowNodeCard";

const PALETTE_TYPES = ["agent", "condition", "transform", "webhook", "api", "api_call", "manual_approval", "protocol_intel"];

export default function NodePalette() {
    const onDragStart = (e, type) => {
        e.dataTransfer.setData("application/sitecentric-node-type", type);
        e.dataTransfer.effectAllowed = "move";
    };

    return (
        <div className="border border-white/10 bg-[#0a0a0a] rounded-md p-3 space-y-2 w-56" data-testid="node-palette">
            <div className="label-xs text-white/40 mb-2">Drag to canvas</div>
            {PALETTE_TYPES.map((type) => {
                const v = TYPE_VISUAL[type];
                const Icon = v.icon;
                return (
                    <div
                        key={type}
                        draggable
                        onDragStart={(e) => onDragStart(e, type)}
                        data-testid={`palette-${type}`}
                        className="flex items-center gap-2 px-2.5 py-2 bg-[#050505] border border-white/10 rounded-md cursor-grab active:cursor-grabbing hover:border-white/30 transition-colors"
                    >
                        <div
                            className="w-6 h-6 rounded flex items-center justify-center shrink-0"
                            style={{ backgroundColor: `${v.color}20`, color: v.color }}
                        >
                            <Icon className="w-3.5 h-3.5" strokeWidth={2} />
                        </div>
                        <div className="text-xs flex-1">{v.label}</div>
                    </div>
                );
            })}
        </div>
    );
}

export { PALETTE_TYPES };
